module.exports = __webpack_public_path__ + "img/tutorial.79c6bb4b.png";